import { GraphQLClient } from "graphql-request";
import * as stats2 from "../generated/stats2.sdk";
import { lazyInit } from "./utils";
export const getStats2GraphqlClient = lazyInit(async () => new GraphQLClient(window.__ENV_CONFIG.apiUrls.stats2));
export const getStats2Sdk = lazyInit(() => getStats2GraphqlClient().then(stats2.getSdk));
//# sourceMappingURL=stats2.js.map